import React, { useCallback, useContext, useEffect, useState } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import { useIntl } from "gatsby-plugin-react-intl"
import HTMLReactParser from "html-react-parser"
import Title from "../common/title"
import StyledButton from "../common/styledButton"
import CartContext from "../../context/CartContext"
import "./blockInfoDetails.scss"
import * as moment from "moment"
import { debounce } from "../functions"

const BlockInfoDetails = ({
  pageTitle,
  id,
  featuredImage,
  price,
  priceChild,
  intro,
  info,
}) => {
  const breakpoint = 801

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
          typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  const intl = useIntl()
  const data = useStaticQuery(graphql`
    query expMenuQuery {
      expMenuQueryEN: allBlockContentBlockCollectableExperiences(
        filter: { langcode: { eq: "en" }, popup_booking_cta: {title: {ne: "test"}} }
      ) {
        nodes {
          popup_booking_cta {
            title
            url
          }
        }
      }

      expMenuQueryFR: allBlockContentBlockCollectableExperiences(
        filter: { langcode: { eq: "fr" }, popup_booking_cta: {title: {ne: "test"}} }
      ) {
        nodes {
          popup_booking_cta {
            title
            url
          }
        }
      }
    }
  `)

  let dataMenuExperiencePlan
  let listingUrl
  switch (intl.locale) {
    case "fr":
      if (data.expMenuQueryFR) {
        dataMenuExperiencePlan = data.expMenuQueryFR.nodes[0]
      }
      listingUrl = "/planifier-sejour-ile-maurice"
      break
    default:
      if (data.expMenuQueryEN) {
        dataMenuExperiencePlan = data.expMenuQueryEN.nodes[0]
        listingUrl = "/en/plan-stay-mauritius"
      }
  }

  const {
    experiences,
    show,
    setShow,
    addToCart,
    numChild,
    numAdults,
    startDate,
    adultPrice,
    childPrice,
    totalPrice,
  } = useContext(CartContext)
  const experience = {
    pageTitle,
    id,
    intro,
    featuredImage,
    price,
    priceChild,
    numChild,
    numAdults,
    startDate,
    adultPrice,
    childPrice,
    totalPrice,
  }
  const experienceExist = experiences.some(exp => exp.id === experience.id)

  let isValid = true
  if (experienceExist) {
    isValid = false
  }

  const finalizeQuote = () => {
    setShow("")
  }
  const closePopup = () => {
    setShow("")
  }
  const scrollToElem = useCallback(e => {
    const element = document.getElementById("collectable-experience")
    setTimeout(() => {
      window.scrollTo({
        top: element.offsetTop,
        behavior: "smooth",
      })
    }, 200)
  }, [])

  return (
    <>
      <div id="popUpExp" className={`popUp-container ${show}`}>
        <div className="popUp">
          <button className="btnClose jsClosePopup" onClick={closePopup}>
            <span>Close</span>
          </button>
          <div className="description">
            <span>
              {intl.formatMessage({ id: "pop-up-exp.msg-conf-1" })}
              <br />
              <span className="description__title">{`${pageTitle}`}</span>
              <br />
              {intl.formatMessage({ id: "pop-up-exp.msg-conf-2" })}
            </span>
          </div>
          <div className="expBookDetails">
            <div className="adults">
              <p>{intl.formatMessage({ id: "add-to-cart.no-of-adults" })}</p>
              <span className="expBookDetails__values">
                {experience.numAdults}
              </span>
            </div>
            {numChild && (
              <div className={numChild ? "child" : "child hide"}>
                <p>
                  {intl.formatMessage({ id: "add-to-cart.no-of-children" })}
                </p>
                <span className="expBookDetails__values">
                  {experience.numChild}
                </span>
              </div>
            )}
            <div className="date">
              <p>{intl.formatMessage({ id: "add-to-cart.date-popup" })}</p>
              <span className="expBookDetails__values">
                {moment(experience.startDate).format("DD MMMM YYYY")}
              </span>
            </div>
            <div className="price">
              <p>{intl.formatMessage({ id: "add-to-cart.price" })}</p>
              <span className="expBookDetails__values">
                {intl.locale == "en"
                  ? `€ ${experience.totalPrice}`
                  : `${experience.totalPrice} €`}
              </span>
            </div>
          </div>
          <h3>{intl.formatMessage({ id: "pop-up-exp.subtitle" })}</h3>
          {/*<Title heading={3} text={intl.formatMessage({ id: "pop-up-exp.subtitle" })} />*/}
          <a
            className="btn btnPrimary btnClose finalizeQuote"
            href={listingUrl}
          >
            <span>{intl.formatMessage({ id: "pop-up-exp.btn-2" })}</span>
          </a>
          {dataMenuExperiencePlan.popup_booking_cta && (
            <Link
              className="btn btnPrimary finalizeQuote"
              onClick={finalizeQuote}
              to={dataMenuExperiencePlan.popup_booking_cta?.url}
            >
              <span>{intl.formatMessage({ id: "cart-link.msg-1" })}</span>
            </Link>
          )}

          {/* <br/> */}
        </div>
      </div>
      <section className="blkInfoDetails" data-scroll-section>
        <Container>
          <Row data-scroll>
            <Col md={12} xs={12} className="blk-wysiwig">
              {info.title && (
                <Title heading={3} text={info.title} />
              )}
              {info.details && (
                HTMLReactParser(info.details.processed)
              )}
              <div className="btnCont">
                {info.gallery_link && (
                  <StyledButton
                    title={info.gallery_link.title}
                    path={info.gallery_link.url}
                  />
                )}
                {info.booking_cta_title && (
                  <>
                    {!isValid ? (
                      <Link className="btn btnPrimary btnFinalize" to={dataMenuExperiencePlan.popup_booking_cta?.url}>
                        <span>{intl.formatMessage({id: "cart-link.msg-1",})}</span>
                      </Link>
                    ):(
                      <>
                        {isClient && screen.isMobile ? (
                          <button onClick={scrollToElem} className={"btn btnPrimary"} >
                            <span>{info.booking_cta_title}</span>
                          </button>
                        ) : (
                          <button onClick={scrollToElem} className={"btn btnPrimary"} >
                            <span>{info.booking_cta_title}</span>
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export const query = graphql`
  fragment infoDetails on paragraph__details {
    internal {
      type
    }
    title
    details {
      processed
    }
    gallery_link {
      title
      url
    }
    booking_cta_title
  }
`

export default BlockInfoDetails
